import { PluginContext } from './context';
import type { PluginProviderCtx } from '../types';

export const PluginsProvider = ({
  children,
  ...fns
}: React.PropsWithChildren<PluginProviderCtx>) => (
  <PluginContext.Provider value={fns}>{children}</PluginContext.Provider>
);
